<template>
  <div
    style="padding:10px;margin-top:10px;"
    :class="
      $store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
        ? window.width > 400
          ? 'card'
          : ''
        : 'text-resize-colidee'
    "
  >
    <div class="columns is-mobile is-multiline">
      <div
        ref="scrollToTheTop"
        :class="
          window.width > 480 && window.width < 1350
            ? 'column is-4-tablet is-6-mobile is-4-desktop'
            : 'column is-4-tablet is-12-mobile is-3-desktop'
        "
        v-for="(insight, index) in ['addButton', ...insights_affiche]"
        :key="index"
      >
        <div v-if="insight === 'addButton'" class="card shadow-card">
          <ButtonAddInsight />
        </div>
        <!-- cards list -->
        <div
          v-else
          :class="
            insight.state == false
              ? 'over'
              : insight.open_at != '1970-01-01 00:00:00' &&
                insight.open_at != null &&
                new Date(insight.open_at) &&
                new Date(insight.open_at) > now
              ? 'programmed'
              : insight.close_at != '1970-01-01 00:00:00' &&
                insight.close_at != null &&
                new Date(insight.close_at) < now
              ? 'over'
              : 'open'
          "
          class="card shadow-card"
        >
          <div :class="!insight.state ? 'state-closed' : ''" class="card-image">
            <div :style="background(insight.media)"></div>
          </div>
          <div class="">
            <div class="media">
              <div class="media-content">
                <div style="text-align:center">
                  <p
                    :class="!insight.state ? 'state-closed' : ''"
                    style="position:absolute;top:150px;left:10px;"
                  >
                    {{
                      insight.created_at
                        .substring(0, 10)
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                  </p>
                  <div
                    style="display:flex;position:absolute;top:150px;right:10px;"
                  >
                    <WhoIsOwner :insight="insight" />
                    <ParametersDropdown :cardIndex="index" :insight="insight" />
                  </div>
                  <p :class="!insight.state ? 'state-closed' : ''">
                    {{
                      $tc("insight.participants", insight.participants_count, {
                        count: insight.participants_count,
                      })
                    }}
                  </p>
                  <p
                    :class="!insight.state ? 'state-closed' : ''"
                    style="font-size:13px; color:black; font-weight:bold; margin-top:20px;"
                  >
                    {{ insight.name }}
                  </p>
                  <p :class="!insight.state ? 'state-closed' : ''">
                    {{
                      insight.client !== null
                        ? insight.client
                        : $t("insight.inconnu")
                    }}
                  </p>
                  <p :class="!insight.state ? 'state-closed' : ''">
                    {{
                      insight.evenement !== null
                        ? insight.evenement
                        : $t("insight.inconnu")
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <footer
            :class="!insight.state ? 'state-closed' : ''"
            class="card-footer"
          >
            <button
              @click="resultatsGroup(insight.url_moderateur)"
              :class="'card-footer-item button button-params'"
            >
              {{ $t("tooltip.results.group") }}
            </button>
            <button
              @click="resultatsIndividual(insight.url_moderateur)"
              class="card-footer-item button button-params"
            >
              {{ $t("tooltip.results.individual") }}
            </button>
          </footer>
        </div>
      </div>
    </div>
    <b-modal :width="640" v-model="modalQrCode.activeModalQrCode">
      <ModalQrCode :modalQrCode="modalQrCode" />
    </b-modal>
    <b-modal :width="640" v-model="modalShares.activeModalShares">
      <ModalShare :modalShares="modalShares"
    /></b-modal>
    <b-modal :width="640" v-model="modalDuplicate.activeModalDuplicate">
      <ModalDuplicate :modalDuplicate="modalDuplicate" />
    </b-modal>
    <b-modal
      :width="640"
      v-model="modalExportExcelPdf.activeModalExportExcelPdf"
    >
      <ModalExportExcelPdf :modalExportExcelPdf="modalExportExcelPdf"
    /></b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ButtonAddInsight from "@/components/insight/PageAdmin/components/ButtonAddInsight";
import ParametersDropdown from "@/components/insight/PageAdmin/components/ParametersDropdown";
import ModalQrCode from "@/components/insight/PageAdmin/components/ModalQrCode";
import ModalShare from "@/components/insight/PageAdmin/components/ModalShare";
import ModalDuplicate from "@/components/insight/PageAdmin/components/ModalDuplicate";
import ModalExportExcelPdf from "@/components/insight/PageAdmin/components/ModalExportExcelPdf";
import WhoIsOwner from "@/components/insight/PageAdmin/components/WhoIsOwner";
export default {
  name: "CardsList",
  components: {
    ButtonAddInsight,
    ParametersDropdown,
    ModalQrCode,
    ModalShare,
    ModalDuplicate,
    ModalExportExcelPdf,
    WhoIsOwner,
  },
  props: ["window"],
  updated() {
    this.$nextTick(function() {
      let message = {
        height: document.body.scrollHeight,
      };
      window.top.postMessage(message, "*");
    });
  },
  mounted() {
    window.scrollTo(0, 0);
    this.sendMessageToParent("scrollToTop");
    this.$store.commit("CLEAR_FIELDS");
    this.$store.dispatch("getInsights");
    this.$store.commit("IS_LOADING_RESULTATS", true);
    this.$store.commit("INSIGHT_BUTTON_DASHBOARD_ROUE", "dashboard");
    this.$store.commit("INSIGHT_BUTTON_ROUE_LISTE", "roue");
    this.$store.commit("INSIGHT_CHECKROWS_PARTICIPANTS", []);
    this.$store.commit("INSIGHT_ADMIN_PARTICIPANTS_TERMINE", []);
    this.$store.commit("INSIGHT_ADMIN_DATA", []);
    this.$store.commit("INSIGHT_ADMIN_DATA_COPY", []);
    this.$store.commit("INSIGHT_TOTAL_PARTICIPANTS_PTS", []);
    this.$store.commit("INSIGHT_TOTAL_PARTICIPANTS_COLOR", []);
    this.$store.commit("INSIGHT_TOTAL_PARTICIPANTS_PTS_CHECKBOXS", []);
    this.$store.commit("INSIGHT_TOTAL_PARTICIPANTS_COLOR_CHECKBOXS", []);
    if (this.$store.state.insight.search_query.length) {
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        searchBar: true,
        cardList: true,
        parameters: false,
      });
    }
  },
  computed: {
    ...mapGetters([
      "insights_affiche",
      "modalQrCode",
      "modalShares",
      "modalDuplicate",
      "modalExportExcelPdf",
    ]),
    now: function() {
      return new Date();
    },
  },
  methods: {
    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo,
      };
      window.top.postMessage(message, "*");
    },
    resultatsGroup(url_moderateur) {
      this.$router.push({
        name: "resultats",
        params: { url_moderateur: url_moderateur, type: "resultatGroup" },
      });
    },
    resultatsIndividual(url_moderateur) {
      this.$router.push({
        name: "resultats",
        params: { url_moderateur: url_moderateur, type: "resultatIndividual" },
      });
    },
    background(urlMedia) {
      if (urlMedia === null) {
        if (window.width < 480) {
        }
        return (
          "height:130px; width:100%; background-size: cover;background-position: center;background-image:url(" +
          require("@/assets/img/medaillonsondages.png") +
          ")"
        );
      } else {
        return (
          "height:130px; width:100%;background-size: cover;background-position: center;background-image:url(" +
          process.env.VUE_APP_URL_MEDIA +
          urlMedia +
          ")"
        );
      }
    },
  },
};
</script>
<style scoped>
.button {
  border-color: none;
  border-radius: 0px;
  font-size: 12px;
  height: 100%;
}
.button:hover {
  border-color: none;
  border-radius: 0px;
  font-size: 12px;
  height: 100%;
  text-decoration: none;
}
.button:disabled {
  border-color: none;
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
  font-size: 12px;
  height: 100%;
}
.shadow-card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.state-closed {
  opacity: 0.3;
}
.button-delete {
  padding: 5px 7px;
  background-color: #e6ecf0;
}
.button-delete:hover {
  background-color: red;
  color: white;
}
.button-params {
  padding: 5px 7px;
  background-color: #e6ecf0;
}
.button-params:hover {
  background-color: #424a60;
  color: white;
}
.text-resize-colidee {
  font-size: 10px;
}
.open {
  border-top: 2px solid green;
}
.over {
  border-top: 2px solid red;
}
.programmed {
  border-top: 2px solid orange;
}
</style>
